import { SxProps } from '@mui/material';

import { CustomTypography } from '@/shared/ui/Typography';

import { StyledNotFoundDataContainer } from './styles';

type NotFoundDataProps = {
  title?: string;
  caption?: string;
  actionSlot?: React.ReactNode;
  sx?: SxProps;
};

export const NotFoundData = ({
  caption,
  actionSlot,
  title,
  ...otherProps
}: NotFoundDataProps) => {
  return (
    <StyledNotFoundDataContainer {...otherProps}>
      <CustomTypography variant="h5" sx={{ paddingBottom: '13px' }}>
        {title}
      </CustomTypography>
      <CustomTypography
        variant="subtitle1"
        sx={{
          paddingBottom: '33px',
          color: (theme) => theme.palette.custom.black[60],
        }}
      >
        {caption}
      </CustomTypography>
      {actionSlot}
    </StyledNotFoundDataContainer>
  );
};
